import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useReadOnlyMode } from "@src/features/publicShareLinks/hooks/useReadOnlyMode";
import { AnalyticsProductPickerDialog } from "@src/features/sharedExperience/components/configureAnalytics/AnalyticsProductPickerDialog";
import { SetAnalyticsViewType } from "@src/features/sharedExperience/components/configureAnalytics/SetAnalyticsViewType";
import {
  getAnalyticsProducts,
  removeAnalyticsProducts,
} from "@src/store/slices/analyticsProducts";
import { setExperienceAnalyticsViewType } from "@src/store/slices/experiences";
import { deselectProduct } from "@src/store/slices/productPicker";

export const SetDetails = () => {
  const dispatch = useDispatch();
  const { isReadOnly } = useReadOnlyMode();
  const analyticsProducts = useSelector(getAnalyticsProducts);

  const onDelete = (productId: string) => {
    if (analyticsProducts.length === 1) {
      dispatch(setExperienceAnalyticsViewType("sitewide_orders"));
    }
    dispatch(deselectProduct(productId));
    dispatch(
      removeAnalyticsProducts({
        productIds: [productId],
      })
    );
  };

  return (
    <Stack direction={"column"} spacing={5}>
      <SetAnalyticsViewType
        onDelete={onDelete}
        analyticsProducts={analyticsProducts}
        isReadOnly={isReadOnly}
      />
      {!isReadOnly && <AnalyticsProductPickerDialog />}
    </Stack>
  );
};
